const SchedulesPage = () => (
  <div>SchedulesPage</div>
);

export default SchedulesPage;
